export default __webpack_public_path__ + "static/media/Collision.0e2eec31.png";